
export var jmol_colors = [
[1.000,0.000,0.000] ,// None
[1.000,1.000,1.000], // H
[0.851,1.000,1.000], // He
[0.800,0.502,1.000], // Li
[0.761,1.000,0.000], // Be
[1.000,0.710,0.710], // B
[0.565,0.565,0.565], // C
[0.188,0.314,0.973], // N
[1.000,0.051,0.051], // O
[0.565,0.878,0.314], // F
[0.702,0.890,0.961], // Ne
[0.671,0.361,0.949], // Na
[0.541,1.000,0.000], // Mg
[0.749,0.651,0.651], // Al
[0.941,0.784,0.627], // Si
[1.000,0.502,0.000], // P
[1.000,1.000,0.188], // S
[0.122,0.941,0.122], // Cl
[0.502,0.820,0.890], // Ar
[0.561,0.251,0.831], // K
[0.239,1.000,0.000], // Ca
[0.902,0.902,0.902], // Sc
[0.749,0.761,0.780], // Ti
[0.651,0.651,0.671], // V
[0.541,0.600,0.780], // Cr
[0.612,0.478,0.780], // Mn
[0.878,0.400,0.200], // Fe
[0.941,0.565,0.627], // Co
[0.314,0.816,0.314], // Ni
[0.784,0.502,0.200], // Cu
[0.490,0.502,0.690], // Zn
[0.761,0.561,0.561], // Ga
[0.400,0.561,0.561], // Ge
[0.741,0.502,0.890], // As
[1.000,0.631,0.000], // Se
[0.651,0.161,0.161], // Br
[0.361,0.722,0.820], // Kr
[0.439,0.180,0.690], // Rb
[0.000,1.000,0.000], // Sr
[0.580,1.000,1.000], // Y
[0.580,0.878,0.878], // Zr
[0.451,0.761,0.788], // Nb
[0.329,0.710,0.710], // Mo
[0.231,0.620,0.620], // Tc
[0.141,0.561,0.561], // Ru
[0.039,0.490,0.549], // Rh
[0.000,0.412,0.522], // Pd
[0.753,0.753,0.753], // Ag
[1.000,0.851,0.561], // Cd
[0.651,0.459,0.451], // In
[0.400,0.502,0.502], // Sn
[0.620,0.388,0.710], // Sb
[0.831,0.478,0.000], // Te
[0.580,0.000,0.580], // I
[0.259,0.620,0.690], // Xe
[0.341,0.090,0.561], // Cs
[0.000,0.788,0.000], // Ba
[0.439,0.831,1.000], // La
[1.000,1.000,0.780], // Ce
[0.851,1.000,0.780], // Pr
[0.780,1.000,0.780], // Nd
[0.639,1.000,0.780], // Pm
[0.561,1.000,0.780], // Sm
[0.380,1.000,0.780], // Eu
[0.271,1.000,0.780], // Gd
[0.188,1.000,0.780], // Tb
[0.122,1.000,0.780], // Dy
[0.000,1.000,0.612], // Ho
[0.000,0.902,0.459], // Er
[0.000,0.831,0.322], // Tm
[0.000,0.749,0.220], // Yb
[0.000,0.671,0.141], // Lu
[0.302,0.761,1.000], // Hf
[0.302,0.651,1.000], // Ta
[0.129,0.580,0.839], // W
[0.149,0.490,0.671], // Re
[0.149,0.400,0.588], // Os
[0.090,0.329,0.529], // Ir
[0.816,0.816,0.878], // Pt
[1.000,0.820,0.137], // Au
[0.722,0.722,0.816], // Hg
[0.651,0.329,0.302], // Tl
[0.341,0.349,0.380], // Pb
[0.620,0.310,0.710], // Bi
[0.671,0.361,0.000], // Po
[0.459,0.310,0.271], // At
[0.259,0.510,0.588], // Rn
[0.259,0.000,0.400], // Fr
[0.000,0.490,0.000], // Ra
[0.439,0.671,0.980], // Ac
[0.000,0.729,1.000], // Th
[0.000,0.631,1.000], // Pa
[0.000,0.561,1.000], // U
[0.000,0.502,1.000], // Np
[0.000,0.420,1.000], // Pu
[0.329,0.361,0.949], // Am
[0.471,0.361,0.890], // Cm
[0.541,0.310,0.890], // Bk
[0.631,0.212,0.831], // Cf
[0.702,0.122,0.831], // Es
[0.702,0.122,0.729], // Fm
[0.702,0.051,0.651], // Md
[0.741,0.051,0.529], // No
[0.780,0.000,0.400], // Lr
[0.800,0.000,0.349], // Rf
[0.820,0.000,0.310], // Db
[0.851,0.000,0.271], // Sg
[0.878,0.000,0.220], // Bh
[0.902,0.000,0.180], // Hs
[0.922,0.000,0.149]  // Mt
]

// Previous colors are the REAL jmol colors. following list contains VESTA colors.

export var vesta_colors = [
[1.000,0.000,0.000] ,// None
[1.00000,0.80000,0.80000] ,// H
[0.98907,0.91312,0.81091] ,// He
[0.52731,0.87953,0.45670] ,// Li
[0.37147,0.84590,0.48292] ,// Be
[0.12490,0.63612,0.05948] ,// B
[0.50430,0.28659,0.16236] ,// C
[0.69139,0.72934,0.90280] ,// N
[0.99997,0.01328,0.00000] ,// O
[0.69139,0.72934,0.90280] ,// F
[0.99954,0.21788,0.71035] ,// Ne
[0.97955,0.86618,0.23787] ,// Na
[0.98773,0.48452,0.08470] ,// Mg
[0.50718,0.70056,0.84062] ,// Al
[0.10596,0.23226,0.98096] ,// Si
[0.75557,0.61256,0.76425] ,// P
[1.00000,0.98071,0.00000] ,// S
[0.19583,0.98828,0.01167] ,// Cl
[0.81349,0.99731,0.77075] ,// Ar
[0.63255,0.13281,0.96858] ,// K
[0.35642,0.58863,0.74498] ,// Ca
[0.71209,0.38930,0.67279] ,// Sc
[0.47237,0.79393,1.00000] ,// Ti
[0.90000,0.10000,0.00000] ,// V
[0.00000,0.00000,0.62000] ,// Cr
[0.66148,0.03412,0.62036] ,// Mn
[0.71051,0.44662,0.00136] ,// Fe
[0.00000,0.00000,0.68666] ,// Co
[0.72032,0.73631,0.74339] ,// Ni
[0.13390,0.28022,0.86606] ,// Cu
[0.56123,0.56445,0.50799] ,// Zn
[0.62292,0.89293,0.45486] ,// Ga
[0.49557,0.43499,0.65193] ,// Ge
[0.45814,0.81694,0.34249] ,// As
[0.60420,0.93874,0.06122] ,// Se
[0.49645,0.19333,0.01076] ,// Br
[0.98102,0.75805,0.95413] ,// Kr
[1.00000,0.00000,0.60000] ,// Rb
[0.00000,1.00000,0.15259] ,// Sr
[0.40259,0.59739,0.55813] ,// Y
[0.00000,1.00000,0.00000] ,// Zr
[0.29992,0.70007,0.46459] ,// Nb
[0.70584,0.52602,0.68925] ,// Mo
[0.80574,0.68699,0.79478] ,// Tc
[0.81184,0.72113,0.68089] ,// Ru
[0.80748,0.82205,0.67068] ,// Rh
[0.75978,0.76818,0.72454] ,// Pd
[0.72032,0.73631,0.74339] ,// Ag
[0.95145,0.12102,0.86354] ,// Cd
[0.84378,0.50401,0.73483] ,// In
[0.60764,0.56052,0.72926] ,// Sn
[0.84627,0.51498,0.31315] ,// Sb
[0.67958,0.63586,0.32038] ,// Te
[0.55914,0.12200,0.54453] ,// I
[0.60662,0.63218,0.97305] ,// Xe
[0.05872,0.99922,0.72578] ,// Cs
[0.11835,0.93959,0.17565] ,// Ba
[0.35340,0.77057,0.28737] ,// La
[0.82055,0.99071,0.02374] ,// Ce
[0.99130,0.88559,0.02315] ,// Pr
[0.98701,0.55560,0.02744] ,// Nd
[0.00000,0.00000,0.96000] ,// Pm
[0.99042,0.02403,0.49195] ,// Sm
[0.98367,0.03078,0.83615] ,// Eu
[0.75325,0.01445,1.00000] ,// Gd
[0.44315,0.01663,0.99782] ,// Tb
[0.19390,0.02374,0.99071] ,// Dy
[0.02837,0.25876,0.98608] ,// Ho
[0.28688,0.45071,0.23043] ,// Er
[0.00000,0.00000,0.88000] ,// Tm
[0.15323,0.99165,0.95836] ,// Yb
[0.15097,0.99391,0.71032] ,// Lu
[0.70704,0.70552,0.35090] ,// Hf
[0.71952,0.60694,0.33841] ,// Ta
[0.55616,0.54257,0.50178] ,// W
[0.70294,0.69401,0.55789] ,// Re
[0.78703,0.69512,0.47379] ,// Os
[0.78975,0.81033,0.45049] ,// Ir
[0.79997,0.77511,0.75068] ,// Pt
[0.99628,0.70149,0.22106] ,// Au
[0.82940,0.72125,0.79823] ,// Hg
[0.58798,0.53854,0.42649] ,// Tl
[0.32386,0.32592,0.35729] ,// Pb
[0.82428,0.18732,0.97211] ,// Bi
[0.00000,0.00000,1.00000] ,// Po
[0.00000,0.00000,1.00000] ,// At
[1.00000,1.00000,0.00000] ,// Rn
[0.00000,0.00000,0.00000] ,// Fr
[0.42959,0.66659,0.34786] ,// Ra
[0.39344,0.62101,0.45034] ,// Ac
[0.14893,0.99596,0.47106] ,// Th
[0.16101,0.98387,0.20855] ,// Pa
[0.47774,0.63362,0.66714] ,// U
[0.30000,0.30000,0.30000] ,// Np
[0.30000,0.30000,0.30000] ,// Pu
[0.30000,0.30000,0.30000] ,// Am
[0.471,0.361,0.890], // Cm
[0.541,0.310,0.890], // Bk
[0.631,0.212,0.831], // Cf
[0.702,0.122,0.831], // Es
[0.702,0.122,0.729], // Fm
[0.702,0.051,0.651], // Md
[0.741,0.051,0.529], // No
[0.780,0.000,0.400], // Lr
[0.800,0.000,0.349], // Rf
[0.820,0.000,0.310], // Db
[0.851,0.000,0.271], // Sg
[0.878,0.000,0.220], // Bh
[0.902,0.000,0.180], // Hs
[0.922,0.000,0.149]  // Mt
]

export var atomic_number = {}
atomic_number['H' ]  =1
atomic_number['He']  =2
atomic_number['Li']  =3
atomic_number['Be']  =4
atomic_number['B' ]  =5
atomic_number['C' ]  =6
atomic_number['N' ]  =7
atomic_number['O' ]  =8
atomic_number['F' ]  =9
atomic_number['Ne']  =10
atomic_number['Na']  =11
atomic_number['Mg']  =12
atomic_number['Al']  =13
atomic_number['Si']  =14
atomic_number['P' ]  =15
atomic_number['S' ]  =16
atomic_number['Cl']  =17
atomic_number['Ar']  =18
atomic_number['K' ]  =19
atomic_number['Ca']  =20
atomic_number['Sc']  =21
atomic_number['Ti']  =22
atomic_number['V' ]  =23
atomic_number['Cr']  =24
atomic_number['Mn']  =25
atomic_number['Fe']  =26
atomic_number['Co']  =27
atomic_number['Ni']  =28
atomic_number['Cu']  =29
atomic_number['Zn']  =30
atomic_number['Ga']  =31
atomic_number['Ge']  =32
atomic_number['As']  =33
atomic_number['Se']  =34
atomic_number['Br']  =35
atomic_number['Kr']  =36
atomic_number['Rb']  =37
atomic_number['Sr']  =38
atomic_number['Y' ]  =39
atomic_number['Zr']  =40
atomic_number['Nb']  =41
atomic_number['Mo']  =42
atomic_number['Tc']  =43
atomic_number['Ru']  =44
atomic_number['Rh']  =45
atomic_number['Pd']  =46
atomic_number['Ag']  =47
atomic_number['Cd']  =48
atomic_number['In']  =49
atomic_number['Sn']  =50
atomic_number['Sb']  =51
atomic_number['Te']  =52
atomic_number['I' ]  =53
atomic_number['Xe']  =54
atomic_number['Cs']  =55
atomic_number['Ba']  =56
atomic_number['La']  =57
atomic_number['Ce']  =58
atomic_number['Pr']  =59
atomic_number['Nd']  =60
atomic_number['Pm']  =61
atomic_number['Sm']  =62
atomic_number['Eu']  =63
atomic_number['Gd']  =64
atomic_number['Tb']  =65
atomic_number['Dy']  =66
atomic_number['Ho']  =67
atomic_number['Er']  =68
atomic_number['Tm']  =69
atomic_number['Yb']  =70
atomic_number['Lu']  =71
atomic_number['Hf']  =72
atomic_number['Ta']  =73
atomic_number['W' ]  =74
atomic_number['Re']  =75
atomic_number['Os']  =76
atomic_number['Ir']  =77
atomic_number['Pt']  =78
atomic_number['Au']  =79
atomic_number['Hg']  =80
atomic_number['Tl']  =81
atomic_number['Pb']  =82
atomic_number['Bi']  =83
atomic_number['Po']  =84
atomic_number['At']  =85
atomic_number['Rn']  =86
atomic_number['Fr']  =87
atomic_number['Ra']  =88
atomic_number['Ac']  =89
atomic_number['Th']  =90
atomic_number['Pa']  =91
atomic_number['U' ]  =92
atomic_number['Np']  =93
atomic_number['Pu']  =94
atomic_number['Am']  =95
atomic_number['Cm']  =96
atomic_number['Bk']  =97
atomic_number['Cf']  =98
atomic_number['Es']  =99
atomic_number['Fm']  =100
atomic_number['Md']  =101
atomic_number['No']  =102
atomic_number['Lr']  =103
atomic_number['Rf']  =104
atomic_number['Db']  =105
atomic_number['Sg']  =106
atomic_number['Bh']  =107
atomic_number['Hs']  =108
atomic_number['Mt']  =109


export var atomic_symbol = ['','H','He','Li','Be','B','C','N','O','F','Ne','Na','Mg','Al','Si',
'P','S','Cl','Ar','K' ,'Ca','Sc','Ti','Vi','Cr','Mn','Fe','Co','Ni','Cu','Zn','Ga',
'Ge','As','Se','Br','Kr','Rb','Sr','Y' ,'Zr','Nb','Mo','Tc','Ru','Rh','Pd','Ag',
'Cd','In','Sn','Sb','Te','I' ,'Xe','Cs','Ba','La','Ce','Pr','Nd','Pm','Sm','Eu',
'Gd','Tb','Dy','Ho','Er','Tm','Yb','Lu','Hf','Ta','W' ,'Re','Os','Ir','Pt','Au',
'Hg','Tl','Pb','Bi','Po','At','Rn','Fr','Ra','Ac','Th','Pa','U' ,'Np','Pu','Am',
'Cm','Bk','Cf','Es','Fm','Md','No','Lr','Rf','Db','Sg','Bh','Hs','Mt'];

//from phonopy
export var atomic_mass = [null,1.00794,4.002602,6.941,9.012182,10.811,12.0107,14.0067,15.9994,
18.9984032,20.1797, 22.98976928,24.305,26.9815386,28.0855,30.973762,32.065,35.453,39.948,
39.0983,40.078,44.955912,47.867,50.9415,51.9961,54.938045,55.845,58.933195,58.6934,63.546,
65.38,69.723,72.64,74.9216,78.96,79.904,83.798,85.4678,87.62,88.90585,91.224,92.90638,95.96,
null,101.07,102.9055,106.42,107.8682,112.411,114.818,118.71,121.76,127.6,126.90447,131.293,
132.9054519,137.327,138.90547,140.116,140.90765,144.242,null,150.36,151.964,157.25,
158.92535,162.5,164.93032,167.259,168.93421,173.054,174.9668,178.49,180.94788,183.84,
186.207,190.23,192.217,195.084,196.966569,200.59,204.3833,207.2,208.9804,null,null,null,
null,null,null,232.03806,231.03588,238.02891,null,null,null,null,null,null,null,null,
null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null]


export var vesta_radius =[null, 0.200,1.220,0.590,0.270,0.110,0.150,1.460,1.400,1.330,1.600,1.020,
0.720,0.390,0.260,0.170,1.840,1.810,1.920,1.510,1.120,0.745,0.605,0.580,0.615,0.830,0.780,
0.745,0.690,0.730,0.740,0.620,0.530,0.335,1.980,1.960,1.980,1.610,1.260,1.019,0.720,0.640,
0.590,0.560,0.620,0.665,0.860,1.150,0.950,0.800,0.690,0.760,2.210,2.200,0.480,1.740,1.420,
1.160,0.970,1.126,1.109,1.093,1.270,1.066,1.053,1.040,1.027,1.015,1.004,0.994,0.985,0.977,
0.710,0.640,0.600,0.530,0.630,0.625,0.625,1.370,1.020,0.885,1.190,1.030,0.940,0.620,0.800,
1.800,1.480,1.120,1.050,0.780,0.730,0.750,0.860,0.975,0.800,null,null,null,null,null,null,
null,null,null,null,null,null,null]

/* Covalent radii from:

  Covalent radii revisited,
  Beatriz Cordero, Verónica Gómez, Ana E. Platero-Prats, Marc Revés,
  Jorge Echeverría, Eduard Cremades, Flavia Barragán and Santiago Alvarez,
  Dalton Trans., 2008, 2832-2838 DOI:10.1039/B801115J
  */

export var covalent_radii =
[0.0,  0.31, 0.28, 1.28, 0.96, 0.84, 0.76, 0.71, 0.66, 0.57, //0
 0.58, 1.66, 1.41, 1.21, 1.11, 1.07, 1.05, 1.02, 1.06, 2.03, //1
 1.76, 1.70, 1.60, 1.53, 1.39, 1.39, 1.32, 1.26, 1.24, 1.32, //2
 1.22, 1.22, 1.20, 1.19, 1.20, 1.20, 1.16, 2.20, 1.95, 1.90, //3
 1.75, 1.64, 1.54, 1.47, 1.46, 1.42, 1.39, 1.45, 1.44, 1.42, //4
 1.39, 1.39, 1.38, 1.39, 1.40, 2.44, 2.15, 2.07, 2.04, 2.03, //5
 2.01, 1.99, 1.98, 1.98, 1.96, 1.94, 1.92, 1.92, 1.89, 1.90, //6
 1.87, 1.87, 1.75, 1.70, 1.62, 1.51, 1.44, 1.41, 1.36, 1.36, //7
 1.32, 1.45, 1.46, 1.48, 1.40, 1.50, 1.50, 2.60, 2.21, 2.15, //8
 2.06, 2.00, 1.96, 1.90, 1.87, 1.80, 1.69, 0,    0,    0,    //9
 0,    0,    0,    0 ]                                       //10
